import { render, staticRenderFns } from "./FormMedicalFollowup.vue?vue&type=template&id=55fa7d94&scoped=true"
import script from "./FormMedicalFollowup.vue?vue&type=script&lang=js"
export * from "./FormMedicalFollowup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fa7d94",
  null
  
)

export default component.exports